var $de7b4d0f7dc86fc8$exports = {};
$de7b4d0f7dc86fc8$exports = {
  "ascending": "ascendente",
  "ascendingSort": function ascendingSort(args) {
    return "Ordenar por coluna ".concat(args.columnName, " em ordem ascendente");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixels");
  },
  "descending": "descendente",
  "descendingSort": function descendingSort(args) {
    return "Ordenar por coluna ".concat(args.columnName, " em ordem descendente");
  },
  "resizerDescription": "Prima Enter para iniciar o redimensionamento",
  "select": "Selecionar",
  "selectAll": "Selecionar tudo",
  "sortable": "Coluna orden\xE1vel"
};
export { $de7b4d0f7dc86fc8$exports as default };